<template>
    <BreadCrumb PageTitle="Paiement autres recettes" />
    <Paiement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Paiement from "../../components/PaiementRecette/PaiementAutreRecettes.vue";
    export default defineComponent({
      name: "PaiementAutreRecettesPage",
      components: {
        BreadCrumb,
        Paiement,
      },
    });
  </script>